import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { checkoutApi } from '../../api/checkoutApi';
import Navbar from '../Navbar';

const ArtozphereCheckoutSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { clearCart } = useCart();
  const [status, setStatus] = useState('confirming');
  const confirmationStarted = useRef(false);

  useEffect(() => {
    if (confirmationStarted.current) return;
    confirmationStarted.current = true;

    const sessionId = searchParams.get('session_id');

    const confirmPurchase = async () => {
      if (!sessionId) {
        setStatus('missing_session');
        return;
      }

      try {
        await checkoutApi.confirmCheckout(sessionId);
        clearCart();
        setStatus('success');
      } catch (err) {
        console.error('Failed to confirm purchase:', err);
        setStatus('error');
      }
    };

    confirmPurchase();
  }, [searchParams, clearCart]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center">
      <Navbar />
      <div className="ml-0 md:ml-20 bg-white p-10 rounded shadow text-center max-w-md mx-4">
        {status === 'confirming' && (
          <>
            <h1 className="text-3xl font-bold mb-4">Processing payment...</h1>
            <p className="mb-4">Saving your order, please wait.</p>
          </>
        )}
        {status === 'success' && (
          <>
            <h1 className="text-3xl font-bold mb-4">Payment Successful!</h1>
            <p className="mb-4">Thank you for your purchase. Your order has been saved.</p>
          </>
        )}
        {status === 'error' && (
          <>
            <h1 className="text-3xl font-bold mb-4">Payment received</h1>
            <p className="mb-4 text-gray-600">
              Payment succeeded but we could not confirm your order yet. Check your profile
              shortly or contact support.
            </p>
          </>
        )}
        {status === 'missing_session' && (
          <>
            <h1 className="text-3xl font-bold mb-4">Payment Successful!</h1>
            <p className="mb-4">
              Thank you for your purchase. A receipt has been sent to your email.
            </p>
          </>
        )}
        <div className="flex flex-col gap-2">
          <button
            type="button"
            onClick={() => navigate('/artozphere')}
            className="bg-gray-700 text-white px-6 py-2 rounded hover:bg-black transition"
          >
            Back to Artozphere
          </button>
          <button
            type="button"
            onClick={() => navigate('/home')}
            className="text-gray-600 px-6 py-2 rounded hover:underline"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default ArtozphereCheckoutSuccess;
